module.exports = __webpack_public_path__ + "img/img07.e1256006.jpg";